/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Doctoral8Inputs */

const en_job_form_enum_doctoral8 = /** @type {(inputs: Job_Form_Enum_Doctoral8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doctoral`)
};

const de_job_form_enum_doctoral8 = /** @type {(inputs: Job_Form_Enum_Doctoral8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion`)
};

/**
* | output |
* | --- |
* | "Doctoral" |
*
* @param {Job_Form_Enum_Doctoral8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_doctoral8 = /** @type {((inputs?: Job_Form_Enum_Doctoral8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Doctoral8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_doctoral8(inputs)
	return en_job_form_enum_doctoral8(inputs)
});
export { job_form_enum_doctoral8 as "job_form_enum_DOCTORAL" }